import React, { Fragment } from 'react';
import { FaInstagram } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import moment from 'moment';

const Footer = props => {
   return (
      <Fragment>
         <footer
            id="#contact"
            style={{ background: '#343a40', color: '#87898A' }}
            className="z-10 py-6 px-4 md:px-12 text-center"
         >
            <div className="bg-gray-50 h-1/2 w-full flex md:flex-row flex-col justify-around items-start pr-20 pl-20">
               <div className="p-5 ">
                  <ul>
                     <p className="text-yellow-500 font-bold text-3xl pb-6">
                        GUB<span className="text-blue-600">SHOP</span>
                     </p>
                     <div className="flex gap-6 pb-5">
                        <FaInstagram className="text-2xl cursor-pointer hover:text-yellow-600" />
                        <FaTwitter className="text-2xl cursor-pointer hover:text-blue-600" />
                        <FaLinkedin className="text-2xl cursor-pointer hover:text-blue-600" />
                        <FaYoutube className="text-2xl cursor-pointer hover:text-red-600" />
                     </div>
                  </ul>
               </div>
               <div className="pt-3 pl-3 pr-3">
                  <ul>
                     <p className="text-white font-bold text-2xl pb-4">
                        Contact Info
                     </p>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Shop no: B/201
                     </li>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                     Jamuna Future Park
                     </li>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        +8801700000 
                     </li>
                     <li className="text-gray-500 text-md font-semibold hover:text-blue-600 cursor-pointer">
                     gubshop@gmail.com
                     </li>
                  </ul>
               </div>
               <div className="pt-3 pl-3 pr-3">
                  <ul>
                     <p className="text-white font-bold text-2xl pb-4">
                      Know About Us
                     </p>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Who We Are
                     </li>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Store Location
                     </li>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Blog
                     </li>
                  </ul>
               </div>
               <div className="pt-3 pl-3 pr-3">
                  <ul>
                     <p className="text-white font-bold text-2xl pb-4">
                        Shopping & Service
                     </p>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Shipping & Charges
                     </li>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Billing & Payment
                     </li>
                     <li className="text-gray-500 text-md pb-2 font-semibold hover:text-blue-600 cursor-pointer">
                        Return & Exchange
                     </li>
                  </ul>
               </div>
            </div>
            <div className="bg-gray-700 opacity-50 mt-4 flex flex-col justify-center items-center text-center rounded-lg  p-5 bg-gray-50">
               <h1 className="text-gray-00 font-semibold">
                  This is a final project by GUB Student{' '}
                  {moment().format('YYYY')}
               </h1>
            </div>
         </footer>
      </Fragment>
   );
};

export default Footer;
